'use strict';

/**
 * @ngdoc service
 * @name scrapQcrmApp.customerPaymentQr
 * @description
 * Payment QR codes of a customer (max 5). Every call is scoped to the customer id in the URL.
 * Images are fetched with the login header and shown from memory (object URLs), never from a public link.
 */
angular.module('scrapQcrmApp')
    .factory('customerPaymentQr', function ($http, $q, $global, Upload, httpService) {

        // same limits as the API (checked there again)
        var MAX_FILE_SIZE = 2 * 1024 * 1024;
        var ALLOWED_TYPES = ['image/png', 'image/jpeg', 'image/webp'];
        var UPI_ID = /^[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}$/;

        function baseUrl(customerId) {
            return $global.getApiUrl() + '/api/customers/' + encodeURIComponent(customerId) + '/payment-qrs';
        }

        // file type from the first bytes, like the API: PNG, JPEG or WEBP only
        function sniffType(file) {
            var deferred = $q.defer();
            var reader = new FileReader();
            reader.onload = function () {
                var b = new Uint8Array(reader.result);
                var type = null;
                if (b.length >= 12) {
                    if (b[0] === 0x89 && b[1] === 0x50 && b[2] === 0x4E && b[3] === 0x47) {
                        type = 'image/png';
                    } else if (b[0] === 0xFF && b[1] === 0xD8 && b[2] === 0xFF) {
                        type = 'image/jpeg';
                    } else if (b[0] === 0x52 && b[1] === 0x49 && b[2] === 0x46 && b[3] === 0x46 &&
                        b[8] === 0x57 && b[9] === 0x45 && b[10] === 0x42 && b[11] === 0x50) {
                        type = 'image/webp';
                    }
                }
                deferred.resolve(type);
            };
            reader.onerror = function () {
                deferred.resolve(null);
            };
            reader.readAsArrayBuffer(file.slice(0, 12));
            return deferred.promise;
        }

        return {
            MAX_FILE_SIZE: MAX_FILE_SIZE,
            MAX_QRS: 5,

            // resolves with an error message, or null when the file can be sent
            checkFile: function (file) {
                if (!file) {
                    return $q.when('Please choose a QR image.');
                }
                if (file.size > MAX_FILE_SIZE) {
                    return $q.when('The file is larger than 2 MB.');
                }
                if (file.type && ALLOWED_TYPES.indexOf(file.type) === -1) {
                    return $q.when('Only PNG, JPG and WEBP images are allowed.');
                }
                return sniffType(file).then(function (type) {
                    return type ? null : 'Only PNG, JPG and WEBP images are allowed.';
                });
            },

            isValidUpiId: function (value) {
                return !!value && UPI_ID.test(String(value).trim());
            },

            list: function (customerId, canceller) {
                return $http.get(baseUrl(customerId), {
                    headers: $global.getAuthorization(),
                    timeout: canceller
                }).then(function (res) {
                    return res.data;
                });
            },

            // object URL of the image; the caller must revoke it when no longer shown
            imageUrl: function (customerId, qrId, canceller) {
                return $http.get(baseUrl(customerId) + '/' + encodeURIComponent(qrId) + '/image', {
                    headers: $global.getAuthorization(),
                    responseType: 'blob',
                    timeout: canceller
                }).then(function (res) {
                    return URL.createObjectURL(res.data);
                });
            },

            preview: function (customerId, file) {
                return Upload.upload({
                    url: baseUrl(customerId) + '/preview',
                    headers: $global.getAuthorization(),
                    data: { file: file }
                }).then(function (res) {
                    return res.data;
                });
            },

            // returns the Upload promise so the caller can show progress
            add: function (customerId, file, label, confirmDuplicate, confirmLabelMismatch) {
                return Upload.upload({
                    url: baseUrl(customerId),
                    headers: $global.getAuthorization(),
                    data: {
                        file: file,
                        label: label || '',
                        confirmDuplicate: !!confirmDuplicate,
                        confirmLabelMismatch: !!confirmLabelMismatch
                    }
                });
            },

            replaceImage: function (customerId, qrId, file, confirmDuplicate, confirmLabelMismatch) {
                return Upload.upload({
                    url: baseUrl(customerId) + '/' + encodeURIComponent(qrId) + '/image',
                    headers: $global.getAuthorization(),
                    data: {
                        file: file,
                        confirmDuplicate: !!confirmDuplicate,
                        confirmLabelMismatch: !!confirmLabelMismatch
                    }
                });
            },

            updateLabel: function (customerId, qrId, label, confirmLabelMismatch) {
                return httpService.httpRequest(baseUrl(customerId) + '/' + encodeURIComponent(qrId) + '/update', 'P', {
                    updateLabel: true,
                    label: label || '',
                    confirmLabelMismatch: !!confirmLabelMismatch
                });
            },

            setPrimary: function (customerId, qrId) {
                return httpService.httpRequest(baseUrl(customerId) + '/' + encodeURIComponent(qrId) + '/update', 'P', {
                    primary: true
                });
            },

            reorder: function (customerId, qrIds) {
                return httpService.httpRequest(baseUrl(customerId) + '/order', 'P', { qrIds: qrIds });
            },

            remove: function (customerId, qrId) {
                return httpService.httpRequest(baseUrl(customerId) + '/' + encodeURIComponent(qrId) + '/delete', 'P', {});
            }
        };
    });
